export interface DetailsProps {
  details: string[];
}
export default function Details({ details }: DetailsProps) {
  return (
    <div style={{ display: "flex", padding: "12px 0px" }}>
      {details.map((x, index) => {
        const last = index === details.length - 1;
        const first = index === 0;
        return (
          <span
            key={index}
            style={{
              color: "#8F8F8F",
              fontSize: 12,
              padding: "0px 8px",
              ...(!last && { borderLeft: "1px solid #CCCCCC" }),
              ...(first && { paddingRight: 0 }),
            }}
          >
            {x}
          </span>
        );
      })}
    </div>
  );
}
